import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ROL_TYPE } from '@app/constants/enums';
import { StorageService } from '../../storage/storage.service';
import { UserService } from '../../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate {

  userData: any;

  constructor(
    private storage: StorageService,
    private router: Router,
    private _user: UserService
  ) { }

  async canActivate(): Promise<boolean> {
    if (this.storage.get('loggedIn') && await this.isAdmin()) {
      return true;
    }
    return false;
  }

  async isAdmin(): Promise<boolean> {
    let res = false;
    await this._user.checkRolType([ROL_TYPE.admin]).then(data => {
      res = data.value;
    });
    return res;
  }

}
